import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {IWinRatioConfig} from "../interfaces/Interface";
import {Game} from "../Game";
import {GameFeatureMode, WinRatioType} from "../enums/Enum";
import {gsap} from "gsap";

export class Sound {

    //Loops
    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static X_MENTAL_SPIN_LOOP: string = "xMentalSpinLoop";
    public static FS_BG_MUSIC: string = "background-music-freespin";
    public static CFS_BG_MUSIC: string = "background-music-coolfreespin";
    public static SFS_BG_MUSIC: string = "background-music-superfreespin";
    public static INTRO_HOSPITAL_LOOP: string = "introHospitalLoop";
    public static WIN_CAP_LOOP: string = "winCapLoop";
    public static IDLE_LOOP_MAIN: string = "idleLoopMain";
    public static IDLE_LOOP_TOPS: string[] = ["idleLoopTop1", "idleLoopTop2", "idleLoopTop3", "idleLoopTop4"];

    public static FS_INTRO_LOOP: string = "fsIntroLoop";
    public static FS_OUTRO_LOOP: string = "fsOutroLoop";
    public static CFS_INTRO_LOOP: string = "cfsIntroLoop";
    public static CFS_OUTRO_LOOP: string = "cfsOutroLoop";
    public static CFS_OUTRO_INITIAL: string = "cfsOutroInitial";
    public static CFS_OUTRO_COUNT_UP: string = "cfsOutroCountUp";
    public static CFS_OUTRO_COUNT_UP_END: string = "cfsOutroCountUpEnd";
    public static SFS_INTRO_LOOP: string = "sfsIntroLoop";
    public static SFS_OUTRO_LOOP: string = "sfsOutroLoop";

    //Effects
    public static WIN_CAP_START: string = "winCapStart"; // #342

    public static PRE_WIN_TINY_SMALL_MEDIUM: string = "preWinTinySmallMedium";
    public static PRE_WIN_LARGE: string = "preWinLarge";

    public static FS_OUTRO_ONE_SHOT: string = "fsOutroOneShot";
    public static FS_OUTRO_COUNT_UP: string = "fsOutroCountUp";
    public static FS_OUTRO_COUNT_UP_END: string = "fsOutroCountUpEnd";

    public static CONTINUE_BUTTON: string = "continueButton";
    public static CONTINUE_BUTTON_START_FS: string = "continueButtonStartFs";
    public static CONTINUE_BUTTON_START_CFS: string = "continueButtonStartCfs";
    public static CONTINUE_BUTTON_START_SFS: string = "continueButtonStartSfs";
    public static CONTINUE_BUTTON_FS_TO_MAIN: string = "continueButtonFsToMain";
    public static CONTINUE_BUTTON_CFS_TO_MAIN: string = "continueButtonCfsToMain";
    public static CONTINUE_BUTTON_SFS_TO_MAIN: string = "continueButtonSfsToMain";
    public static CONTINUE_BUTTON_WIN_CAP: string = "winCapContinueButton";

    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];

    public static X_GOD_REEL_SPINNING: string[] = ["xGodReelSpin", "xGodReelSpin2"];
    public static X_GOD_FINAL_REEL_ANTICIPATION: string = "xGodFinalReelAnticipation";
    public static X_GOD_SYMBOL_LANDING: string = "xGodSymbolLanding";
    public static X_GOD_FAIL: string = "xGodFail";
    public static X_GOD_MEGA_SYMBOL_REVEAL: string = "xGodMegaSymbolReveal";

    public static GAME_INTRO_ELEVATOR_SCENE: string = "gameIntroElevatorScene";
    public static ELEVATOR_FROM_MAIN_TO_FS: string = "elevatorFromMainToFS";
    public static ELEVATOR_FROM_MAIN_TO_CFS: string = "elevatorFromMainToCFS";
    public static ELEVATOR_FROM_MAIN_TO_SFS: string = "elevatorFromMainToSFS";
    public static ELEVATOR_FROM_SFS_TO_MAIN: string = "elevatorFromSFSToMain";

    public static COUNT_UP: string = "countup";
    public static WIN_LARGE_COUNT_UP: string = "winLargeCountUp";
    public static COUNT_UP_END_TINY: string = "winTiny";
    public static COUNT_UP_END_SMALL: string = "winSmall";
    public static COUNT_UP_END_MEDIUM: string = "winMedium";
    public static COUNT_UP_END_LARGE: string = "winLargeEnd";

    public static FIRE_FRAME_ARR: string[] = ["fireFrame1", "fireFrame2", "fireFrame3"];
    public static FIRE_FRAME_SPLITS_ARR: string[] = ["fireFrameSplit1", "fireFrameSplit2", "fireFrameSplit3", "fireFrameSplit4"];

    public static ENHANCER_ACTIVATION_FIRE: string = "enhancerActivationFire";
    public static ENHANCER_OPEN: string = "enhancerOpen";

    public static BIGWIN_ANTICIPATION: string = "bigWinAnticipation";
    public static BIGWIN_INIT: string = "bigWinInit";
    public static BIGWIN_LEVELS: string[] = ["bigWinLevel1", "bigWinLevel2", "bigWinLevel3", "bigWinLevel4", "bigWinLevel5", "bigWinLevel6"];
    public static BIGWIN_LEVEL_CHANGE: string = "bigWinLevelChange";
    public static BIGWIN_END: string = "bigWinEnd";

    public static X_NUDGE1: string = "xNudgeNudge1";
    public static X_NUDGE2: string = "xNudgeNudge2";
    public static X_NUDGE3: string = "xNudgeNudge3";

    public static X_SPLIT_START: string = "xSplitStart";
    public static X_SPLIT_SPLITTING: string = "xSplitSplitting";
    public static X_SPLIT_END: string = "xSplitEnd";

    public static X_HOLE_ANTICIPATION: string = "xHoleAnticipation";
    public static X_HOLE_LAND_ACTIVE: string = "xHoleLandActive";
    public static X_HOLE_SPIT_OUT: string = "xHoleSpitOut";
    public static X_HOLE_SUCK: string = "xHoleSuck";
    public static X_HOLE_MISS: string = "xHoleMiss";

    public static X_WAYS_EXPAND: string = "xWaysExpand";
    public static X_WAYS_EXPLODE: string = "xWaysExplode";
    public static X_WAYS_REVEAL: string = "xWaysReveal";

    public static IDLE_FLICKERS: string[] = ["idleFlicker1", "idleFlicker2", "idleFlicker3"];
    public static SYMBOL_LOCKED: string = "symbolLocked";
    public static SFS_INTRO_LOOP_START: string = "sfsIntroLoopStart";
    public static S2_TRANSFORM: string = "s2Transform";
    public static DEAD_LAND: string = "deadSymbolLand";
    public static DEAD_SYMBOL_REVEAL: string[] = ["fireFrameSplit1", "fireFrameSplit2", "fireFrameSplit3", "fireFrameSplit4"];
    public static S1_LAND: string [] = ["scatter1Land", "scatter2Land", "scatter3Land"];
    public static S1_LAND_DEAD: string [] = ["scatter1Land", "scatter1Land", "scatter1Land"];
    public static S1_ANTICIPATION: string = "anticipation";
    public static S1_ANTICIPATION_END: string = "anticipationEnd";
    public static S1_ANTICIPATION_REEL_STOP: string = "anticipationReelStop";
    public static S1_ACTIVATION: string = "scatterActivation";
    public static SCATTER2_LAND: string = "scatterS2Land";
    public static DEAD_MULTI_TO_STICKY: string = "deadSymbolMultiContainer";
    public static STICKY_MULTI_TO_SYMBOL: string = "deadSymbolMultiContainerAddMulti";
    public static WAYS_COUNTER: string = "waysCounter";
    public static BIG_FRAME_ZAP: string = "bigFrameZap";
    public static UPGRADE_SCREEN_COUNT: string = "upgradeScreenCountClick";
    public static UPGRADE_SCREEN_TO_CFS: string = "upgradeScreenToCFS";
    public static UPGRADE_SCREEN_TO_SFS: string = "upgradeScreenToSFS";
    public static X_MENTAL_LANDING: string = "xMentalLanding";
    public static X_MENTAL_END: string = "xMentalEnd";
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asBigWin";
    public static X_MENTAL_BIG_ANIMATION: string = "xMentalBigAnimation";
    public static X_MENTAL_ANTICIPATION: string = "xMentalAnticipation";


    private player: NolimitAudioPlayer;
    private _intervalMap: Map<string, gsap.core.Timeline> = new Map<string, gsap.core.Timeline>();
    private _countUpSound: NolimitHowl | undefined;
    private _bigWinSound: NolimitHowl | undefined;
    private _currentMusic: string;

    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound
    }

    private static createConfig(name: string, volume?: number, repeat?: number) {
        return {
            name: name,
            volume: volume,
            repeat: repeat
        }
    }

    public avoidFrequentPlaySoundAndPlayLastQueued(soundKey: string, soundName: string, interval?: number): boolean {
        let isAlreadyPlayed: boolean = true;
        const oldTL: gsap.core.Timeline | undefined = this._intervalMap.get(soundKey);
        if (oldTL) {
            oldTL.pause().kill();
        }
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        this._intervalMap.set(soundKey, tl)
        tl.to({}, {duration: interval || 0.0001});
        tl.add(() => {
            this.playSound(soundName);
            this._intervalMap.delete(soundKey);
        });
        isAlreadyPlayed = false;
        return isAlreadyPlayed;
    }

    public playFireFrame(): void {
        if (!Sound.FIRE_FRAME_ARR.length) {
            Sound.FIRE_FRAME_ARR = ["fireFrame1", "fireFrame2", "fireFrame3"];
        }
        this.playRandomSoundWithoutRepeat(Sound.FIRE_FRAME_ARR);
    }

    public playFireFrameSplit(): void {
        if (!Sound.FIRE_FRAME_SPLITS_ARR.length) {
            Sound.FIRE_FRAME_SPLITS_ARR = ["fireFrameSplit1", "fireFrameSplit2", "fireFrameSplit3", "fireFrameSplit4"];
        }
        this.playRandomSoundWithoutRepeat(Sound.FIRE_FRAME_SPLITS_ARR);
    }

    public playSound(name: string, volume?: number, repeat?: number): NolimitHowl | undefined {
        Logger.logDev("play sound ", name);
        return this.player.playTrack(Sound.createConfig(name, volume, repeat));
    }

    public stopSound(name: string) {
        Logger.logDev("stop sound " + name);
        this.player.stopTrack(name);
    }

    public stopCurrentMusic(): void {
        if (this._currentMusic) {
            this.player.stopTrack(this._currentMusic);
        }
    }

    public stopXMentalSpinLoop(isBigWin : boolean): void {
        !isBigWin  && this.fadeSound(0, 1, 100);
        this.player.stopTrack(Sound.X_MENTAL_SPIN_LOOP);
    }

    public switchMusic(mode: GameFeatureMode | string) {
        let nextMusic: string = "";

        switch (mode) {
            case GameFeatureMode.FREESPIN:
                nextMusic = Sound.FS_BG_MUSIC;
                break;
            case "FS_INTRO":
                nextMusic = Sound.FS_INTRO_LOOP;
                break;
            case "FS_OUTRO":
                nextMusic = Sound.FS_OUTRO_LOOP;
                break;
            case GameFeatureMode.FREESPIN_COOL:
                nextMusic = Sound.CFS_BG_MUSIC;
                break;
            case "CFS_INTRO":
                nextMusic = Sound.CFS_INTRO_LOOP;
                break;
            case "CFS_OUTRO":
                nextMusic = Sound.CFS_OUTRO_LOOP;
                break;
            case GameFeatureMode.FREESPIN_SUPER:
                nextMusic = Sound.SFS_BG_MUSIC;
                break;
            case "SFS_INTRO":
                nextMusic = Sound.SFS_INTRO_LOOP;
                break;
            case "SFS_OUTRO":
                nextMusic = Sound.SFS_OUTRO_LOOP;
                break;
            case "WIN_CAP_LOOP":
                nextMusic = Sound.WIN_CAP_LOOP;
                break;
            default:
                nextMusic = Sound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            this.player.stopTrack(this._currentMusic);

            if (this._currentMusic === Sound.MAIN_GAME_MUSIC) {
                this.player.stopTrack(Sound.IDLE_LOOP_MAIN);
            }
        }

        let repeat;
        if (mode !== GameFeatureMode.FREESPIN_COOL && mode !== GameFeatureMode.NORMAL && mode !== GameFeatureMode.FREESPIN_SUPER) {
            repeat = Number.MAX_VALUE;
        }
        Logger.logDev("Sound switch music ", this._currentMusic, " to ", nextMusic);
        this.player.playTrack(Sound.createConfig(nextMusic, 1, repeat));
        if (mode === "NORMAL") {
            this.player.playTrack(Sound.createConfig(Sound.IDLE_LOOP_MAIN, 0, repeat));
        }
        this._currentMusic = nextMusic;
    }

    public startCountUp(ratioType: WinRatioType | undefined): void {
        this._countUpSound = this.playSound(ratioType === WinRatioType.LARGE ? Sound.WIN_LARGE_COUNT_UP : Sound.COUNT_UP);
        if (this._countUpSound) {
            this._countUpSound.setLoop(false);
        }
    }

    public stopCountUp(): void {
        if (this._countUpSound && this._countUpSound.isPlaying) {
            //this._countUpSound.stop();
        }
        let winRatioConfig: IWinRatioConfig = Game.model.winRatioConfig;
        let sound: string = Sound.COUNT_UP_END_LARGE;

        if (winRatioConfig) {
            if (winRatioConfig.type === WinRatioType.TINY) {
                sound = Sound.COUNT_UP_END_TINY;
            } else if (winRatioConfig.type === WinRatioType.SMALL) {
                sound = Sound.COUNT_UP_END_SMALL;
            } else if (winRatioConfig.type === WinRatioType.MEDIUM) {
                sound = Sound.COUNT_UP_END_MEDIUM;
            }
        }
        this.playSound(sound);
    }

    public playBigWinSound(level: number) {
        this._bigWinSound = this.playSound(Sound.BIGWIN_LEVELS[level - 1]);
    }

    public stopBigWinSound() {
        if (this._bigWinSound?.isPlaying) {
            this.stopSound(this._bigWinSound.soundName);
        }
    }

    public fadeSound(from: number, to: number, duration: number, name?: string): void {
        const soundName: string = name || this._currentMusic;
        this.player.fadeTrack({
            name: soundName,
            duration: duration,
            from: from,
            to: to
        });
        Logger.logDev("fade Sound ", soundName, "from - ", from, " to - ", to);
    }

    public playRandomSoundWithoutRepeat(soundArr: string[]): string {
        const randomNumber: number = Math.floor(Math.random() * soundArr.length);
        const sound: string = soundArr.splice(randomNumber, 1)[0];
        this.playSound(sound);
        return sound;
    }

    set currentMusic(value: string) {
        this._currentMusic = value;
    }

    get currentMusic(): string {
        return this._currentMusic;
    }
}